// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Messages/Basic.proto (package time_tracking.messages.basic, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any, Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_duration, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { DateTimeOffsetDto, MessageTimestampsDto, UuidDto } from "./Common_pb";
import { file_Messages_Common } from "./Common_pb";
import { file_Options_FieldOptions } from "../Options/FieldOptions_pb";
import { file_Options_ValidationFieldOptions } from "../Options/ValidationFieldOptions_pb";
import type { UserConfigurationEntryReadPermission } from "../Enumerations/UserConfigurationEntryReadPermission_pb";
import { file_Enumerations_UserConfigurationEntryReadPermission } from "../Enumerations/UserConfigurationEntryReadPermission_pb";
import type { WorkingTimeModelDayOfWeek } from "../Enumerations/WorkingTimeModelDayOfWeek_pb";
import { file_Enumerations_WorkingTimeModelDayOfWeek } from "../Enumerations/WorkingTimeModelDayOfWeek_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file Messages/Basic.proto.
 */
export const file_Messages_Basic: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_any, file_google_protobuf_duration, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_Messages_Common, file_Options_FieldOptions, file_Options_ValidationFieldOptions, file_Enumerations_UserConfigurationEntryReadPermission, file_Enumerations_WorkingTimeModelDayOfWeek]);

/**
 * Contains information about the deployed application.
 *
 * @generated from message time_tracking.messages.basic.ApplicationInformationDto
 */
export type ApplicationInformationDto = Message<"time_tracking.messages.basic.ApplicationInformationDto"> & {
  /**
   * The name and version of the underlying operating system.
   *
   * @generated from field: string operating_system_version = 1;
   */
  operatingSystemVersion: string;

  /**
   * The version string of the dotnet runtime executing the application.
   *
   * @generated from field: string dotnet_runtime_version = 2;
   */
  dotnetRuntimeVersion: string;

  /**
   * The git commit hash this application was built from.
   *
   * @generated from field: google.protobuf.StringValue commit_hash = 3;
   */
  commitHash?: string | undefined;

  /**
   * Version information about all loaded assemblies.
   *
   * @generated from field: repeated time_tracking.messages.basic.ApplicationInformationDto.AssemblyInformationDto assembly_information = 4;
   */
  assemblyInformation: ApplicationInformationDto_AssemblyInformationDto[];
};

/**
 * Describes the message time_tracking.messages.basic.ApplicationInformationDto.
 * Use `create(ApplicationInformationDtoSchema)` to create a new message.
 */
export const ApplicationInformationDtoSchema: GenMessage<ApplicationInformationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 0);

/**
 * Contains version information about a loaded assembly.
 *
 * @generated from message time_tracking.messages.basic.ApplicationInformationDto.AssemblyInformationDto
 */
export type ApplicationInformationDto_AssemblyInformationDto = Message<"time_tracking.messages.basic.ApplicationInformationDto.AssemblyInformationDto"> & {
  /**
   * The name of the assembly.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The version string of the assembly.
   *
   * @generated from field: google.protobuf.StringValue assembly_version = 2;
   */
  assemblyVersion?: string | undefined;

  /**
   * The version string of the assembly file.
   *
   * @generated from field: google.protobuf.StringValue file_version = 3;
   */
  fileVersion?: string | undefined;

  /**
   * The git commit hash of the assembly, if it was included.
   *
   * @generated from field: google.protobuf.StringValue commit_hash = 4;
   */
  commitHash?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.ApplicationInformationDto.AssemblyInformationDto.
 * Use `create(ApplicationInformationDto_AssemblyInformationDtoSchema)` to create a new message.
 */
export const ApplicationInformationDto_AssemblyInformationDtoSchema: GenMessage<ApplicationInformationDto_AssemblyInformationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 0, 0);

/**
 * Represents a business that has locations to assign users to.
 *
 * @generated from message time_tracking.messages.basic.BusinessDto
 */
export type BusinessDto = Message<"time_tracking.messages.basic.BusinessDto"> & {
  /**
   * The GUID of the business.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The tenant id of the business.
   *
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * The name of the business.
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * A descriptive text of the business.
   *
   * @generated from field: optional string description = 5;
   */
  description?: string | undefined;

  /**
   * The number of locations of this business.
   * This has to be zero when sending them back to the API, since locations cannot be
   * modified by the UpdateBusiness API call.
   *
   * @generated from field: optional int32 location_count = 6;
   */
  locationCount?: number | undefined;

  /**
   * Optional external reference id.
   *
   * @generated from field: google.protobuf.StringValue external_reference = 7;
   */
  externalReference?: string | undefined;

  /**
   * Contains creation, modification and deletion time stamps.
   * The time stamps have to be null when sending them back to the API, since they cannot be
   * modified by the UpdateBusiness API call.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.BusinessDto.
 * Use `create(BusinessDtoSchema)` to create a new message.
 */
export const BusinessDtoSchema: GenMessage<BusinessDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 1);

/**
 * Represents the location of a business to which users can be assigned to.
 *
 * @generated from message time_tracking.messages.basic.BusinessLocationDto
 */
export type BusinessLocationDto = Message<"time_tracking.messages.basic.BusinessLocationDto"> & {
  /**
   * The GUID of the business location.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The tenant id of the business location.
   *
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * The GUID of the business the location belongs to.
   *
   * @generated from field: time_tracking.messages.common.UuidDto business_id = 4;
   */
  businessId?: UuidDto | undefined;

  /**
   * The name of the business the location belongs to.
   * The business name has to be empty when sending it back to the API, since it cannot be
   * modified by the UpdateBusinessLocation API call.
   *
   * @generated from field: optional string business_name = 5;
   */
  businessName?: string | undefined;

  /**
   * The name of the business location.
   *
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * A descriptive text of the business location.
   *
   * @generated from field: optional string description = 7;
   */
  description?: string | undefined;

  /**
   * Optional external reference id.
   *
   * @generated from field: google.protobuf.StringValue external_reference = 8;
   */
  externalReference?: string | undefined;

  /**
   * Contains creation, modification and deletion time stamps.
   * The time stamps have to be null when sending them back to the API, since they cannot be
   * modified by the UpdateBusinessLocation API call.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.BusinessLocationDto.
 * Use `create(BusinessLocationDtoSchema)` to create a new message.
 */
export const BusinessLocationDtoSchema: GenMessage<BusinessLocationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 2);

/**
 * Represents a configuration entry global to the application.
 *
 * @generated from message time_tracking.messages.basic.GlobalConfigurationEntryDto
 */
export type GlobalConfigurationEntryDto = Message<"time_tracking.messages.basic.GlobalConfigurationEntryDto"> & {
  /**
   * The identifier for the configuration entry.
   *
   * @generated from field: time_tracking.messages.basic.GlobalConfigurationEntryDto.IdentifierDto identifier = 1;
   */
  identifier?: GlobalConfigurationEntryDto_IdentifierDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The value of the configuration entry.
   *
   * @generated from field: google.protobuf.Any configuration_value = 3;
   */
  configurationValue?: Any | undefined;

  /**
   * Contains creation, modification and deletion time stamps.
   * The time stamps have to be null when sending them back to the API, since they cannot be
   * modified by the SetGlobalConfigurationEntry API call.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.GlobalConfigurationEntryDto.
 * Use `create(GlobalConfigurationEntryDtoSchema)` to create a new message.
 */
export const GlobalConfigurationEntryDtoSchema: GenMessage<GlobalConfigurationEntryDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 3);

/**
 * Represents an identifier for a global configuration entry.
 *
 * @generated from message time_tracking.messages.basic.GlobalConfigurationEntryDto.IdentifierDto
 */
export type GlobalConfigurationEntryDto_IdentifierDto = Message<"time_tracking.messages.basic.GlobalConfigurationEntryDto.IdentifierDto"> & {
  /**
   * The key of the configuration entry.
   *
   * @generated from field: string configuration_key = 1;
   */
  configurationKey: string;

  /**
   * The tenant id of the configuration entry.
   *
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;
};

/**
 * Describes the message time_tracking.messages.basic.GlobalConfigurationEntryDto.IdentifierDto.
 * Use `create(GlobalConfigurationEntryDto_IdentifierDtoSchema)` to create a new message.
 */
export const GlobalConfigurationEntryDto_IdentifierDtoSchema: GenMessage<GlobalConfigurationEntryDto_IdentifierDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 3, 0);

/**
 * A theme color stored as a configuration entry.
 *
 * @generated from message time_tracking.messages.basic.GlobalConfigurationEntryDto.ColorDto
 */
export type GlobalConfigurationEntryDto_ColorDto = Message<"time_tracking.messages.basic.GlobalConfigurationEntryDto.ColorDto"> & {
  /**
   * The contained color value.
   *
   * @generated from field: string color = 1;
   */
  color: string;
};

/**
 * Describes the message time_tracking.messages.basic.GlobalConfigurationEntryDto.ColorDto.
 * Use `create(GlobalConfigurationEntryDto_ColorDtoSchema)` to create a new message.
 */
export const GlobalConfigurationEntryDto_ColorDtoSchema: GenMessage<GlobalConfigurationEntryDto_ColorDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 3, 1);

/**
 * A binary logo stored as a configuration entry.
 *
 * @generated from message time_tracking.messages.basic.GlobalConfigurationEntryDto.LogoDto
 */
export type GlobalConfigurationEntryDto_LogoDto = Message<"time_tracking.messages.basic.GlobalConfigurationEntryDto.LogoDto"> & {
  /**
   * The contained binary image data.
   *
   * @generated from field: google.protobuf.BytesValue image = 1;
   */
  image?: Uint8Array | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.GlobalConfigurationEntryDto.LogoDto.
 * Use `create(GlobalConfigurationEntryDto_LogoDtoSchema)` to create a new message.
 */
export const GlobalConfigurationEntryDto_LogoDtoSchema: GenMessage<GlobalConfigurationEntryDto_LogoDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 3, 2);

/**
 * Represents a role a user of the application can possess.
 *
 * @generated from message time_tracking.messages.basic.IdentityRoleDto
 */
export type IdentityRoleDto = Message<"time_tracking.messages.basic.IdentityRoleDto"> & {
  /**
   * The GUID of the role.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The name of the role.
   *
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message time_tracking.messages.basic.IdentityRoleDto.
 * Use `create(IdentityRoleDtoSchema)` to create a new message.
 */
export const IdentityRoleDtoSchema: GenMessage<IdentityRoleDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 4);

/**
 * Represents information about a user that can log in to the application.
 *
 * @generated from message time_tracking.messages.basic.IdentityUserDto
 */
export type IdentityUserDto = Message<"time_tracking.messages.basic.IdentityUserDto"> & {
  /**
   * The GUID of the user.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The tenant id of the user.
   *
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * The email address of the user which is used as the user name for login.
   *
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * Whether the email address of the user has been confirmed or not.
   *
   * @generated from field: optional bool email_confirmed = 5;
   */
  emailConfirmed?: boolean | undefined;

  /**
   * The user name of the user which may just be the email address again.
   *
   * @generated from field: string user_name = 6;
   */
  userName: string;

  /**
   * The user's first name.
   *
   * @generated from field: optional string first_name = 7;
   */
  firstName?: string | undefined;

  /**
   * The user's last name.
   *
   * @generated from field: optional string last_name = 8;
   */
  lastName?: string | undefined;

  /**
   * The roles the user belongs to in the application.
   * The roles have to be empty when sending them back to the API, since they cannot be modified
   * by the UpdateUser API call.
   *
   * @generated from field: repeated time_tracking.messages.basic.IdentityRoleDto roles = 9;
   */
  roles: IdentityRoleDto[];

  /**
   * Optional external reference id.
   *
   * @generated from field: google.protobuf.StringValue external_reference = 10;
   */
  externalReference?: string | undefined;

  /**
   * Contains creation, modification and deletion time stamps.
   * The time stamps have to be null when sending them back to the API, since they cannot be
   * modified by the UpdateUser API call.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.IdentityUserDto.
 * Use `create(IdentityUserDtoSchema)` to create a new message.
 */
export const IdentityUserDtoSchema: GenMessage<IdentityUserDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 5);

/**
 * Contains a user id and a business location id for business location modification.
 *
 * @generated from message time_tracking.messages.basic.IdentityUserBusinessLocationModificationDto
 */
export type IdentityUserBusinessLocationModificationDto = Message<"time_tracking.messages.basic.IdentityUserBusinessLocationModificationDto"> & {
  /**
   * The id of the Identity user to add to or remove from a business location.
   *
   * @generated from field: time_tracking.messages.common.UuidDto user_id = 1;
   */
  userId?: UuidDto | undefined;

  /**
   * The id of the business location to add the user to or remove the user from.
   *
   * @generated from field: time_tracking.messages.common.UuidDto business_location_id = 2;
   */
  businessLocationId?: UuidDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.IdentityUserBusinessLocationModificationDto.
 * Use `create(IdentityUserBusinessLocationModificationDtoSchema)` to create a new message.
 */
export const IdentityUserBusinessLocationModificationDtoSchema: GenMessage<IdentityUserBusinessLocationModificationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 6);

/**
 * Contains a user id and a project id for project modification.
 *
 * @generated from message time_tracking.messages.basic.IdentityUserProjectModificationDto
 */
export type IdentityUserProjectModificationDto = Message<"time_tracking.messages.basic.IdentityUserProjectModificationDto"> & {
  /**
   * The id of the Identity user to add to or remove from a project.
   *
   * @generated from field: time_tracking.messages.common.UuidDto user_id = 1;
   */
  userId?: UuidDto | undefined;

  /**
   * The id of the project to add the user to or remove the user from.
   *
   * @generated from field: time_tracking.messages.common.UuidDto project_id = 2;
   */
  projectId?: UuidDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.IdentityUserProjectModificationDto.
 * Use `create(IdentityUserProjectModificationDtoSchema)` to create a new message.
 */
export const IdentityUserProjectModificationDtoSchema: GenMessage<IdentityUserProjectModificationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 7);

/**
 * Contains a user id and a role id for role modification.
 *
 * @generated from message time_tracking.messages.basic.IdentityUserRoleModificationDto
 */
export type IdentityUserRoleModificationDto = Message<"time_tracking.messages.basic.IdentityUserRoleModificationDto"> & {
  /**
   * The id of the Identity user to assign to or remove from a role.
   *
   * @generated from field: time_tracking.messages.common.UuidDto user_id = 1;
   */
  userId?: UuidDto | undefined;

  /**
   * The id of the Identity role to assign the user to or remove the user from.
   *
   * @generated from field: time_tracking.messages.common.UuidDto role_id = 2;
   */
  roleId?: UuidDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.IdentityUserRoleModificationDto.
 * Use `create(IdentityUserRoleModificationDtoSchema)` to create a new message.
 */
export const IdentityUserRoleModificationDtoSchema: GenMessage<IdentityUserRoleModificationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 8);

/**
 * Contains a user with a password for user creation.
 *
 * @generated from message time_tracking.messages.basic.IdentityUserWithCredentialsDto
 */
export type IdentityUserWithCredentialsDto = Message<"time_tracking.messages.basic.IdentityUserWithCredentialsDto"> & {
  /**
   * The details of the user to create.
   *
   * @generated from field: time_tracking.messages.basic.IdentityUserDto user = 1;
   */
  user?: IdentityUserDto | undefined;

  /**
   * The password to apply to the user.
   * If you change the password validation, make sure to also apply the changes in the AddTimeTrackingIdentity call in Program.cs and the message below.
   *
   * @generated from field: google.protobuf.StringValue password = 2;
   */
  password?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.IdentityUserWithCredentialsDto.
 * Use `create(IdentityUserWithCredentialsDtoSchema)` to create a new message.
 */
export const IdentityUserWithCredentialsDtoSchema: GenMessage<IdentityUserWithCredentialsDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 9);

/**
 * Contains a user id with a password for updating the user's password.
 *
 * @generated from message time_tracking.messages.basic.IdentityUserIdWithCredentialsDto
 */
export type IdentityUserIdWithCredentialsDto = Message<"time_tracking.messages.basic.IdentityUserIdWithCredentialsDto"> & {
  /**
   * The id of the user whose password to modify.
   *
   * @generated from field: time_tracking.messages.common.UuidDto user_id = 1;
   */
  userId?: UuidDto | undefined;

  /**
   * The password to apply to the user.
   * If you change the password validation, make sure to also apply the changes in the AddTimeTrackingIdentity call in Program.cs and the message above.
   *
   * @generated from field: google.protobuf.StringValue password = 2;
   */
  password?: string | undefined;

  /**
   * The current password of the user.
   * If an Administrator wants to modify the password of a user, this field has to be left null.
   * If a User wants to change their own password, this field has to be specified and contain the user's current password.
   *
   * @generated from field: google.protobuf.StringValue current_password = 3;
   */
  currentPassword?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.IdentityUserIdWithCredentialsDto.
 * Use `create(IdentityUserIdWithCredentialsDtoSchema)` to create a new message.
 */
export const IdentityUserIdWithCredentialsDtoSchema: GenMessage<IdentityUserIdWithCredentialsDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 10);

/**
 * Represents a project where users can add trackings to.
 *
 * @generated from message time_tracking.messages.basic.ProjectDto
 */
export type ProjectDto = Message<"time_tracking.messages.basic.ProjectDto"> & {
  /**
   * The GUID of the project.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The tenant id of the project.
   *
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * The name of the project.
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * A descriptive text of the project.
   *
   * @generated from field: optional string description = 5;
   */
  description?: string | undefined;

  /**
   * Specifies the optional start date of the project.
   *
   * @generated from field: google.protobuf.Timestamp start_at = 6;
   */
  startAt?: Timestamp | undefined;

  /**
   * Specifies the optional end date of the project.
   *
   * @generated from field: google.protobuf.Timestamp end_at = 7;
   */
  endAt?: Timestamp | undefined;

  /**
   * Specifies an optional hex color (with optional alpha channel) for projects, for example #aabbccdd.
   *
   * @generated from field: google.protobuf.StringValue display_color = 8;
   */
  displayColor?: string | undefined;

  /**
   * Optional tracking kind id (billable, etc.) that declares which tracking kind should be selected by default.
   *
   * @generated from field: time_tracking.messages.common.UuidDto default_tracking_kind_id = 9;
   */
  defaultTrackingKindId?: UuidDto | undefined;

  /**
   * Optional external reference id.
   *
   * @generated from field: google.protobuf.StringValue external_reference = 10;
   */
  externalReference?: string | undefined;

  /**
   * The name of the optional tracking kind (billable, etc.) that declares which tracking kind should be selected by default.
   * The tracking kind name has to be empty when sending it back to the API, since it cannot be
   * modified by the UpdateProject API call.
   *
   * @generated from field: google.protobuf.StringValue default_tracking_kind_name = 11;
   */
  defaultTrackingKindName?: string | undefined;

  /**
   * Contains creation, modification and deletion time stamps.
   * The time stamps have to be null when sending them back to the API, since they cannot be
   * modified by the UpdateProject API call.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.ProjectDto.
 * Use `create(ProjectDtoSchema)` to create a new message.
 */
export const ProjectDtoSchema: GenMessage<ProjectDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 11);

/**
 * Represents the result of a report generation.
 *
 * @generated from message time_tracking.messages.basic.ReportOutputDto
 */
export type ReportOutputDto = Message<"time_tracking.messages.basic.ReportOutputDto"> & {
  /**
   * The name of the report.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The header names of the included columns.
   *
   * @generated from field: repeated string column_headers = 2;
   */
  columnHeaders: string[];

  /**
   * The rows of the report.
   *
   * @generated from field: repeated time_tracking.messages.basic.ReportOutputDto.RowDto rows = 3;
   */
  rows: ReportOutputDto_RowDto[];
};

/**
 * Describes the message time_tracking.messages.basic.ReportOutputDto.
 * Use `create(ReportOutputDtoSchema)` to create a new message.
 */
export const ReportOutputDtoSchema: GenMessage<ReportOutputDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 12);

/**
 * Represents a single row of a report.
 *
 * @generated from message time_tracking.messages.basic.ReportOutputDto.RowDto
 */
export type ReportOutputDto_RowDto = Message<"time_tracking.messages.basic.ReportOutputDto.RowDto"> & {
  /**
   * The values for this single row.
   *
   * @generated from field: repeated time_tracking.messages.basic.ReportOutputDto.RowValueDto values = 1;
   */
  values: ReportOutputDto_RowValueDto[];
};

/**
 * Describes the message time_tracking.messages.basic.ReportOutputDto.RowDto.
 * Use `create(ReportOutputDto_RowDtoSchema)` to create a new message.
 */
export const ReportOutputDto_RowDtoSchema: GenMessage<ReportOutputDto_RowDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 12, 0);

/**
 * Represents a single row item in a report.
 *
 * @generated from message time_tracking.messages.basic.ReportOutputDto.RowValueDto
 */
export type ReportOutputDto_RowValueDto = Message<"time_tracking.messages.basic.ReportOutputDto.RowValueDto"> & {
  /**
   * Specifies the type of item in this spot.
   *
   * @generated from oneof time_tracking.messages.basic.ReportOutputDto.RowValueDto.content
   */
  content: {
    /**
     * The row value contains some text.
     *
     * @generated from field: string text = 1;
     */
    value: string;
    case: "text";
  } | {
    /**
     * The row value contains a number.
     *
     * @generated from field: double number = 2;
     */
    value: number;
    case: "number";
  } | {
    /**
     * The row value contains a boolean.
     *
     * @generated from field: bool boolean = 3;
     */
    value: boolean;
    case: "boolean";
  } | {
    /**
     * The row value contains a date and time with time zone offset.
     *
     * @generated from field: time_tracking.messages.common.DateTimeOffsetDto date_time_offset = 4;
     */
    value: DateTimeOffsetDto;
    case: "dateTimeOffset";
  } | {
    /**
     * The row value contains a time span.
     *
     * @generated from field: google.protobuf.Duration duration = 5;
     */
    value: Duration;
    case: "duration";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message time_tracking.messages.basic.ReportOutputDto.RowValueDto.
 * Use `create(ReportOutputDto_RowValueDtoSchema)` to create a new message.
 */
export const ReportOutputDto_RowValueDtoSchema: GenMessage<ReportOutputDto_RowValueDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 12, 1);

/**
 * Represents a tenant of the Mogi TimeTracking application.
 *
 * @generated from message time_tracking.messages.basic.TenantDto
 */
export type TenantDto = Message<"time_tracking.messages.basic.TenantDto"> & {
  /**
   * The id representing this tenant.
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;
};

/**
 * Describes the message time_tracking.messages.basic.TenantDto.
 * Use `create(TenantDtoSchema)` to create a new message.
 */
export const TenantDtoSchema: GenMessage<TenantDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 13);

/**
 * Represents a potentially ongoing tracking over a period of time.
 *
 * @generated from message time_tracking.messages.basic.TrackingDto
 */
export type TrackingDto = Message<"time_tracking.messages.basic.TrackingDto"> & {
  /**
   * The GUID of the tracking.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The tenant id of the tracking.
   *
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * The id of the user the tracking belongs to.
   *
   * @generated from field: time_tracking.messages.common.UuidDto user_id = 4;
   */
  userId?: UuidDto | undefined;

  /**
   * The name of the user the tracking belongs to.
   * The user name has to be empty when sending it back to the API, since it cannot be
   * modified by the UpdateTracking API call.
   *
   * @generated from field: optional string user_name = 5;
   */
  userName?: string | undefined;

  /**
   * The optional id of the kind the tracking is (billable, etc.).
   *
   * @generated from field: time_tracking.messages.common.UuidDto tracking_kind_id = 6;
   */
  trackingKindId?: UuidDto | undefined;

  /**
   * The name of the kind the tracking is (billable, etc.).
   * The tracking kind name has to be null when sending it back to the API, since it cannot be
   * modified by the UpdateTracking API call.
   *
   * @generated from field: google.protobuf.StringValue tracking_kind_name = 7;
   */
  trackingKindName?: string | undefined;

  /**
   * The optional id of the project the tracking is associated with.
   *
   * @generated from field: time_tracking.messages.common.UuidDto project_id = 8;
   */
  projectId?: UuidDto | undefined;

  /**
   * The name of the optional project the tracking is associated with.
   * The project name has to be null when sending it back to the API, since it cannot be
   * modified by the UpdateTracking API call.
   *
   * @generated from field: google.protobuf.StringValue project_name = 9;
   */
  projectName?: string | undefined;

  /**
   * The local date and time the tracking was started at (seconds are zero).
   * A tracking always has a starting point, so this field can never be null.
   *
   * @generated from field: time_tracking.messages.common.DateTimeOffsetDto started_at = 10;
   */
  startedAt?: DateTimeOffsetDto | undefined;

  /**
   * The local date and time the tracking was ended at (seconds are zero).
   *
   * @generated from field: time_tracking.messages.common.DateTimeOffsetDto ended_at = 11;
   */
  endedAt?: DateTimeOffsetDto | undefined;

  /**
   * A descriptive text for the tracking used only for internal documentation.
   * This is supposed to be a required field, but since trackings can be created by clicking a
   * button that requires no other interaction, the required-ness of this field is established
   * elsewhere.
   *
   * @generated from field: optional string internal_description = 12;
   */
  internalDescription?: string | undefined;

  /**
   * A descriptive text for the tracking which may be exported to affiliated systems.
   *
   * @generated from field: optional string public_description = 13;
   */
  publicDescription?: string | undefined;

  /**
   * Specifies whether the tracking has been automatically modified by the service and requires user interaction.
   * This has to be set to false when sending it to the backend to indicate manual interaction.
   *
   * @generated from field: optional bool most_recently_modified_by_service = 14;
   */
  mostRecentlyModifiedByService?: boolean | undefined;

  /**
   * Specifies that the tracking can no longer be edited manually by a regular user.
   *
   * @generated from field: optional bool is_locked = 15;
   */
  isLocked?: boolean | undefined;

  /**
   * Optional external reference id.
   *
   * @generated from field: google.protobuf.StringValue external_reference = 16;
   */
  externalReference?: string | undefined;

  /**
   * Contains creation, modification and deletion time stamps.
   * The time stamps have to be null when sending them back to the API, since they cannot be
   * modified by the UpdateTracking API call.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.TrackingDto.
 * Use `create(TrackingDtoSchema)` to create a new message.
 */
export const TrackingDtoSchema: GenMessage<TrackingDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 14);

/**
 * Represents the kind of a tracking (billable, etc.).
 *
 * @generated from message time_tracking.messages.basic.TrackingKindDto
 */
export type TrackingKindDto = Message<"time_tracking.messages.basic.TrackingKindDto"> & {
  /**
   * The GUID of the tracking kind.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The tenant id of the tracking kind.
   *
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * The name of the tracking kind.
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * Contains creation, modification and deletion time stamps.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.TrackingKindDto.
 * Use `create(TrackingKindDtoSchema)` to create a new message.
 */
export const TrackingKindDtoSchema: GenMessage<TrackingKindDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 15);

/**
 * Input for generating a tracking report.
 *
 * @generated from message time_tracking.messages.basic.TrackingReportInputDto
 */
export type TrackingReportInputDto = Message<"time_tracking.messages.basic.TrackingReportInputDto"> & {
  /**
   * Specifies all the projects to include in the report. May be empty if user_ids is not.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto project_ids = 1;
   */
  projectIds: UuidDto[];

  /**
   * Specifies all the users to include in the report. May be empty if project_ids is not.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto user_ids = 2;
   */
  userIds: UuidDto[];

  /**
   * The first date to include in the report.
   *
   * @generated from field: google.protobuf.Timestamp date_from = 3;
   */
  dateFrom?: Timestamp | undefined;

  /**
   * The last date to include in the report.
   *
   * @generated from field: google.protobuf.Timestamp date_to = 4;
   */
  dateTo?: Timestamp | undefined;

  /**
   * Whether to round tracking times to a nearest configurable value.
   *
   * @generated from field: bool perform_rounding = 5;
   */
  performRounding: boolean;

  /**
   * Whether to combine adjacent trackings of the same user and project into one.
   * The join_description_character can be used to specify how descriptions of combined
   * trackings are joined together.
   *
   * @generated from field: bool combine_adjacent_trackings = 6;
   */
  combineAdjacentTrackings: boolean;

  /**
   * Whether to include the tracking duration column in the final report.
   *
   * @generated from field: optional bool include_duration_column = 7;
   */
  includeDurationColumn?: boolean | undefined;

  /**
   * Whether to include the tracking description column in the final report.
   *
   * @generated from field: optional bool include_description_column = 8;
   */
  includeDescriptionColumn?: boolean | undefined;

  /**
   * The text to use when descriptions are being combined.
   *
   * @generated from field: optional string join_description_character = 9;
   */
  joinDescriptionCharacter?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.TrackingReportInputDto.
 * Use `create(TrackingReportInputDtoSchema)` to create a new message.
 */
export const TrackingReportInputDtoSchema: GenMessage<TrackingReportInputDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 16);

/**
 * Represents a collection of trackings belonging to a particular user and date.
 *
 * @generated from message time_tracking.messages.basic.TrackingsOfDayDto
 */
export type TrackingsOfDayDto = Message<"time_tracking.messages.basic.TrackingsOfDayDto"> & {
  /**
   * The id of the user all of the trackings in the collection have to belong to.
   *
   * @generated from field: time_tracking.messages.common.UuidDto user_id = 1;
   */
  userId?: UuidDto | undefined;

  /**
   * The date all of the trackings in the collection have to belong to.
   *
   * @generated from field: google.protobuf.Timestamp date = 2;
   */
  date?: Timestamp | undefined;

  /**
   * The trackings contained in this collection.
   *
   * @generated from field: repeated time_tracking.messages.basic.TrackingDto trackings = 3;
   */
  trackings: TrackingDto[];

  /**
   * If set to true, the trackings of the collection are validated but not persisted into the database.
   *
   * @generated from field: bool validate_only = 4;
   */
  validateOnly: boolean;
};

/**
 * Describes the message time_tracking.messages.basic.TrackingsOfDayDto.
 * Use `create(TrackingsOfDayDtoSchema)` to create a new message.
 */
export const TrackingsOfDayDtoSchema: GenMessage<TrackingsOfDayDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 17);

/**
 * Represents a configuration entry for a specific user.
 *
 * @generated from message time_tracking.messages.basic.UserConfigurationEntryDto
 */
export type UserConfigurationEntryDto = Message<"time_tracking.messages.basic.UserConfigurationEntryDto"> & {
  /**
   * The identifier for the configuration entry.
   *
   * @generated from field: time_tracking.messages.basic.UserConfigurationEntryDto.IdentifierDto identifier = 1;
   */
  identifier?: UserConfigurationEntryDto_IdentifierDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The value of the configuration entry.
   *
   * @generated from field: google.protobuf.Any configuration_value = 3;
   */
  configurationValue?: Any | undefined;

  /**
   * The tenant id of the configuration entry.
   *
   * @generated from field: string tenant_id = 4;
   */
  tenantId: string;

  /**
   * Specifies who can read this user configuration entry.
   *
   * @generated from field: time_tracking.enumerations.UserConfigurationEntryReadPermission read_permission = 5;
   */
  readPermission: UserConfigurationEntryReadPermission;

  /**
   * Contains creation, modification and deletion time stamps.
   * The time stamps have to be null when sending them back to the API, since they cannot be
   * modified by the SetGlobalConfigurationEntry API call.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.UserConfigurationEntryDto.
 * Use `create(UserConfigurationEntryDtoSchema)` to create a new message.
 */
export const UserConfigurationEntryDtoSchema: GenMessage<UserConfigurationEntryDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 18);

/**
 * Represents an identifier for a user configuration entry.
 *
 * @generated from message time_tracking.messages.basic.UserConfigurationEntryDto.IdentifierDto
 */
export type UserConfigurationEntryDto_IdentifierDto = Message<"time_tracking.messages.basic.UserConfigurationEntryDto.IdentifierDto"> & {
  /**
   * The key of the configuration entry.
   *
   * @generated from field: string configuration_key = 1;
   */
  configurationKey: string;

  /**
   * The identifier of the user the configuration entry belongs to.
   *
   * @generated from field: time_tracking.messages.common.UuidDto user_id = 2;
   */
  userId?: UuidDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.UserConfigurationEntryDto.IdentifierDto.
 * Use `create(UserConfigurationEntryDto_IdentifierDtoSchema)` to create a new message.
 */
export const UserConfigurationEntryDto_IdentifierDtoSchema: GenMessage<UserConfigurationEntryDto_IdentifierDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 18, 0);

/**
 * @generated from message time_tracking.messages.basic.UserConfigurationEntryDto.OnboardingComplete
 */
export type UserConfigurationEntryDto_OnboardingComplete = Message<"time_tracking.messages.basic.UserConfigurationEntryDto.OnboardingComplete"> & {
  /**
   * @generated from field: bool complete = 1;
   */
  complete: boolean;
};

/**
 * Describes the message time_tracking.messages.basic.UserConfigurationEntryDto.OnboardingComplete.
 * Use `create(UserConfigurationEntryDto_OnboardingCompleteSchema)` to create a new message.
 */
export const UserConfigurationEntryDto_OnboardingCompleteSchema: GenMessage<UserConfigurationEntryDto_OnboardingComplete> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 18, 1);

/**
 * @generated from message time_tracking.messages.basic.UserConfigurationEntryDto.BooleanSetting
 */
export type UserConfigurationEntryDto_BooleanSetting = Message<"time_tracking.messages.basic.UserConfigurationEntryDto.BooleanSetting"> & {
  /**
   * @generated from field: bool value = 1;
   */
  value: boolean;
};

/**
 * Describes the message time_tracking.messages.basic.UserConfigurationEntryDto.BooleanSetting.
 * Use `create(UserConfigurationEntryDto_BooleanSettingSchema)` to create a new message.
 */
export const UserConfigurationEntryDto_BooleanSettingSchema: GenMessage<UserConfigurationEntryDto_BooleanSetting> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 18, 2);

/**
 * Represents a mapping of a working time model to an Identity user.
 *
 * @generated from message time_tracking.messages.basic.UserWorkingTimeModelDto
 */
export type UserWorkingTimeModelDto = Message<"time_tracking.messages.basic.UserWorkingTimeModelDto"> & {
  /**
   * The GUID of the user and working time model association.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * The id of the Identity user associated with a working time model.
   *
   * @generated from field: time_tracking.messages.common.UuidDto user_id = 2;
   */
  userId?: UuidDto | undefined;

  /**
   * The id of the working time model associated with an Identity user.
   *
   * @generated from field: time_tracking.messages.common.UuidDto working_time_model_id = 3;
   */
  workingTimeModelId?: UuidDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 4;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The tenant id of the user / working time model mapping.
   *
   * @generated from field: string tenant_id = 5;
   */
  tenantId: string;

  /**
   * Declares the first day when the working time model will be valid for the user.
   * A working time model association always has to have a valid from time stamp.
   *
   * @generated from field: google.protobuf.Timestamp valid_from = 6;
   */
  validFrom?: Timestamp | undefined;

  /**
   * Declares the last day when the working time model will be valid for the user.
   *
   * @generated from field: google.protobuf.Timestamp valid_until = 7;
   */
  validUntil?: Timestamp | undefined;

  /**
   * Information about the working time model in the association.
   * The working time model has to be null when sending it back to the API, since it
   * cannot be modified by the UpdateUserWorkingTimeModel API call. Use the
   * working_time_model_id field for this.
   *
   * @generated from field: time_tracking.messages.basic.WorkingTimeModelDto working_time_model = 8;
   */
  workingTimeModel?: WorkingTimeModelDto | undefined;

  /**
   * The name of the user the working time model is associated with.
   * The user name has to be empty when sending it back to the API, since it cannot be
   * modified by the UpdateUserWorkingTimeModel API call. Use the user_id field for this.
   *
   * @generated from field: optional string user_name = 9;
   */
  userName?: string | undefined;

  /**
   * Contains creation, modification and deletion time stamps.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.UserWorkingTimeModelDto.
 * Use `create(UserWorkingTimeModelDtoSchema)` to create a new message.
 */
export const UserWorkingTimeModelDtoSchema: GenMessage<UserWorkingTimeModelDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 19);

/**
 * Represents a model for work hours of users.
 *
 * @generated from message time_tracking.messages.basic.WorkingTimeModelDto
 */
export type WorkingTimeModelDto = Message<"time_tracking.messages.basic.WorkingTimeModelDto"> & {
  /**
   * The GUID of the working time model.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * The tenant id of the working time model.
   *
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * The name of the working time model.
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * A descriptive text of the working time model.
   *
   * @generated from field: optional string description = 5;
   */
  description?: string | undefined;

  /**
   * Declares that no tracking is allowed to start before the specified amount of hours and minutes.
   *
   * @generated from field: google.protobuf.Duration no_tracking_before = 6;
   */
  noTrackingBefore?: Duration | undefined;

  /**
   * Declares that no tracking is allowed to end after the specified amount of hours and minutes.
   *
   * @generated from field: google.protobuf.Duration no_tracking_after = 7;
   */
  noTrackingAfter?: Duration | undefined;

  /**
   * Declares that after a continous amount of trackings spanning the given amount of hours and minutes, a pause has to occur.
   *
   * @generated from field: google.protobuf.Duration pause_after = 8;
   */
  pauseAfter?: Duration | undefined;

  /**
   * Declares the minimum length of the required pause.
   *
   * @generated from field: google.protobuf.Duration pause_duration = 9;
   */
  pauseDuration?: Duration | undefined;

  /**
   * Declares the maximum combined length of trackings allowed in a single day.
   *
   * @generated from field: google.protobuf.Duration maximum_work_time_per_day = 10;
   */
  maximumWorkTimePerDay?: Duration | undefined;

  /**
   * Declares whether this person is allowed to create overlapping inter-project trackings.
   *
   * @generated from field: bool allow_overlapping_trackings = 11;
   */
  allowOverlappingTrackings: boolean;

  /**
   * Contains the week-day specific configuration of the working time model.
   *
   * @generated from field: repeated time_tracking.messages.basic.WorkingTimeModelDayDto working_time_model_days = 12;
   */
  workingTimeModelDays: WorkingTimeModelDayDto[];

  /**
   * Specifies the earliest allowed user and working time model associations for this working time model.
   * If this is null, no restrictions exist.
   *
   * @generated from field: google.protobuf.Timestamp assignable_from = 13;
   */
  assignableFrom?: Timestamp | undefined;

  /**
   * Specifies the latest allowed user and working time model associations for this working time model.
   * If this is null, no restrictions exist. If this is set, no open-ended associations are allowed.
   *
   * @generated from field: google.protobuf.Timestamp assignable_until = 14;
   */
  assignableUntil?: Timestamp | undefined;

  /**
   * Optional external reference id.
   *
   * @generated from field: google.protobuf.StringValue external_reference = 15;
   */
  externalReference?: string | undefined;

  /**
   * Contains creation, modification and deletion time stamps.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.WorkingTimeModelDto.
 * Use `create(WorkingTimeModelDtoSchema)` to create a new message.
 */
export const WorkingTimeModelDtoSchema: GenMessage<WorkingTimeModelDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 20);

/**
 * Represents a model for work hours of a single day of users.
 *
 * @generated from message time_tracking.messages.basic.WorkingTimeModelDayDto
 */
export type WorkingTimeModelDayDto = Message<"time_tracking.messages.basic.WorkingTimeModelDayDto"> & {
  /**
   * Specifies the day of week for this working time model day.
   *
   * @generated from field: time_tracking.enumerations.WorkingTimeModelDayOfWeek day_of_week = 1;
   */
  dayOfWeek: WorkingTimeModelDayOfWeek;

  /**
   * The database concurrency stamp to detect concurrent edits.
   *
   * @generated from field: google.protobuf.StringValue concurrency_stamp = 2;
   */
  concurrencyStamp?: string | undefined;

  /**
   * Regular start time of the work day.
   *
   * @generated from field: google.protobuf.Duration work_time_start_at = 3;
   */
  workTimeStartAt?: Duration | undefined;

  /**
   * Regular duration of the work day.
   *
   * @generated from field: google.protobuf.Duration work_time_duration = 4;
   */
  workTimeDuration?: Duration | undefined;

  /**
   * Optional external reference id.
   *
   * @generated from field: google.protobuf.StringValue external_reference = 5;
   */
  externalReference?: string | undefined;

  /**
   * Contains creation, modification and deletion time stamps.
   *
   * @generated from field: time_tracking.messages.common.MessageTimestampsDto timestamps = 100;
   */
  timestamps?: MessageTimestampsDto | undefined;
};

/**
 * Describes the message time_tracking.messages.basic.WorkingTimeModelDayDto.
 * Use `create(WorkingTimeModelDayDtoSchema)` to create a new message.
 */
export const WorkingTimeModelDayDtoSchema: GenMessage<WorkingTimeModelDayDto> = /*@__PURE__*/
  messageDesc(file_Messages_Basic, 21);

